import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';
function Kyagu3({ lang }) {
  const k3 =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fk03.png?alt=media&token=9d6b2678-22f1-4a24-a64a-d6e08bc81ce0';
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Row className='kyaguContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center'>
              {/* Header Image */}
              <Image src={k3} rounded fluid />
              {/* Title */}
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese mb-3 '>
                  瑞巴卡波 1198-1272
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                  བོད་ཡིག་
                </h3>
              ) : (
                <h3 className='text-left text-secondary mb-3'>English</h3>
              )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Tab.Container id='left-tabs' defaultActiveKey='1'>
                <Row>
                  <Col sm={5} md={3}>
                    <Nav variant='pills' className='flex-column '>
                      {/* Tap 1 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='1'>
                          {lang === 'CH' ? (
                            <h4>自傳</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྣམ་ཐར།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 2 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='2'>
                          {lang === 'CH' ? (
                            <h4>大手印</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཕྱག་ཆེན། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 3 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='3'>
                          {lang === 'CH' ? (
                            <h4>那若六法</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཆོས་དྲུག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 4 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='4'>
                          {lang === 'CH' ? (
                            <h4>道歌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>རྡོ་རྗེས་མགུར། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 5 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='5'>
                          {lang === 'CH' ? (
                            <h4>教言</h4>
                          ) : lang === 'TIB' ? (
                            <h4>ཞལ་གདམ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 6 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='6'>
                          {lang === 'CH' ? (
                            <h4>儀軌</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདོན་ཆ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 7 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='7'>
                          {lang === 'CH' ? (
                            <h4>法相</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདྲ་འབག </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 8 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='8'>
                          {lang === 'CH' ? (
                            <h4>法帽</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དབུ་ཞྭ། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 9 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='9'>
                          {lang === 'CH' ? (
                            <h4>佛寺</h4>
                          ) : lang === 'TIB' ? (
                            <h4>དགོན་པ།</h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 10 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='10'>
                          {lang === 'CH' ? (
                            <h4>閉關地</h4>
                          ) : lang === 'TIB' ? (
                            <h4>སྒྲུབ་གནས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 11 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='11'>
                          {lang === 'CH' ? (
                            <h4>加持物</h4>
                          ) : lang === 'TIB' ? (
                            <h4>བྱིན་རླབས། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>

                      {/* Tap 12 */}
                      <Nav.Item className='navItem'>
                        <Nav.Link eventKey='12'>
                          {lang === 'CH' ? (
                            <h4>紀念法會</h4>
                          ) : lang === 'TIB' ? (
                            <h4>འདས་མཆོད། </h4>
                          ) : (
                            <h4>english</h4>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Col>

                  {/* Content */}
                  <Col sm={7} md={9}>
                    <Tab.Content className='tabContent'>
                      <Tab.Pane eventKey='1' className='tabPane'>
                        {lang === 'CH' ? (
                          <p className='chineseParagraph p-2'>
                            敬安• 瑞巴卡波於 1198
                            年生於西夏首府，他是帝師瑞巴在西夏所收的弟子。自幼喜愛佛法，不好世俗事。稍長，由宿願緣故，一聽到衆生怙主帝師瑞巴之名，就産生殊勝敬仰。一次，他帶著大量禮品獻給帝師，上師發現他根器良好，遂收為弟子。從此，他隨侍上師左右，並在僧衆中受出家戒和近圓戒，取名喜饒絳曲(慧菩提)，專心聽講內外諸法。尤其修習那若六法，打通氣脈，容貌猶如滿月般明亮，因此又名
                            (白衣者)，名聲遠播。一次，他從覺達山口向上走，仿佛十五的月亮自山口升起，顯得非常威嚴，許多人都看見了他散發出的萬丈光芒。這位大師的偉大之處不可思議，甚至超越了帝師·瑞巴的成就。
                            帝師·瑞巴圓寂之後，瑞巴卡波駐錫固本寺，僅用五十天就完成上師仁波切靈塔。1237
                            年在住地建設寢室和寺院，稱爲「固本雜瓦」。
                            由於他在修持上的卓越成就與威望，得到元世祖忽必烈的護持來修建固本寺經堂，並供養六地萬戶爲其管轄範圍，
                            瑞巴卡波從西夏召來木匠和石匠，新建佛殿、私邸，面積一百二十柱，共三層。他還在邁欽頂建立修院，臥室和法座至今仍在。由於缺水，他從山頂引出了水，供寺院使用。
                            他將皇帝供養的巨額財富興建了許多廟宇，他特別在囊謙新建了一座規模宏偉的寺廟，裏面擁有難以計數的佛像，其中主要的一尊，就是拉薩覺沃佛像的複制品。最後他也被皇帝尊為相當於帝師瑞巴的精神領袖。。
                            尊者於六十五歲的藏曆水狗年五月十八日時圓寂。
                          </p>
                        ) : lang === 'TIB' ? (
                          <p>
                            <h1>བོད་ཡིག་</h1>
                          </p>
                        ) : (
                          <p>
                            <h1>English</h1>
                          </p>
                        )}
                      </Tab.Pane>
                      <Tab.Pane eventKey='second' className='tabPane'>
                        <p>i am Singapore</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='third' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                      <Tab.Pane eventKey='forth' className='tabPane'>
                        <p>i am tibet</p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu3);
